import { getEnvironmentFromHost } from '@ace-clublabs/log-cannon';
import SplunkOtelWeb from '@splunk/otel-web';
import { splunkRUM } from './constants';

const getAppVersionFromMeta = () => {
  return (
    document?.querySelector('meta[name="version"]')?.getAttribute('content') ||
    'unknown-version'
  );
};

if (import.meta.env.PROD && splunkRUM.SPLUNK_RUM_AUTH) {
  SplunkOtelWeb.init({
    beaconEndpoint: splunkRUM.SPLUNK_BEACON_URL,
    rumAccessToken: splunkRUM.SPLUNK_RUM_AUTH,
    applicationName: splunkRUM.SPLUNK_APP_NAME,
    version: getAppVersionFromMeta(),
    deploymentEnvironment: getEnvironmentFromHost(),
  });
}
